import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../../common/utils';
import { allowedListItemProps } from './_allowedPropTypes';

const CardListItem = ({
  title,
  htmlAttributes: passedAttributes,
  classNames = [],
  cardSize = 'small',
  cardMargin = 'small',
  caption,
  image
}) => {
  const finalAttributes = cloneObject(passedAttributes, { title });

  finalAttributes.className = [
    ...classNames,
    'card-list-item',
    `card-size-${cardSize}`,
    `card-margin-${cardMargin}`
  ].join(' ');

  return (
    <li {...finalAttributes}>
      <div className='picture-frame'>{image}</div>
      <div className='caption-wrap'>{caption}</div>
    </li>
  );
};

CardListItem.propTypes = {
  ...allowedListItemProps,
  htmlAttributes: PropTypes.object
};

export default CardListItem;